import { Link } from "react-router-dom";
import { PLATFORMS } from "@/lib/platforms";

export default function Footer() {
  return (
    <footer className="border-t border-white/70" style={{ background: "rgba(255,255,255,0.45)", backdropFilter: "blur(16px)" }} data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-5 sm:px-10 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-display font-semibold text-2xl">Novcovek</p>
          <p className="mt-3 text-sm text-[var(--ink-soft)] max-w-sm">
            The whole of health, one address. Seven places, one alias, and nobody ever sees your name.
          </p>
          <div className="mt-5 flex gap-2">
            {PLATFORMS.map((p) => (
              <Link key={p.key} to={p.path} aria-label={p.name} className="w-4 h-4 rounded-full block hover:scale-125 transition-transform" style={{ background: p.hue }} data-testid={`footer-dot-${p.key}`} />
            ))}
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="kicker text-[var(--ink-soft)]">The seven</p>
          <ul className="mt-4 space-y-2 text-sm">
            {PLATFORMS.map((p) => (
              <li key={p.key}>
                <Link to={p.path} className="hover:opacity-60 transition-opacity font-medium">{p.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="kicker text-[var(--ink-soft)]">The rest</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/blog" className="hover:opacity-60 transition-opacity font-medium">Blog</Link></li>
            <li><Link to="/why" className="hover:opacity-60 transition-opacity font-medium">Why this exists</Link></li>
            <li><Link to="/contact" className="hover:opacity-60 transition-opacity font-medium">Contact</Link></li>
            <li><Link to="/record" className="hover:opacity-60 transition-opacity font-medium">Your record</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/70">
        <div className="max-w-6xl mx-auto px-5 sm:px-10 py-5 text-xs text-[var(--ink-soft)] flex flex-wrap gap-x-6 gap-y-2 justify-between">
          <span>Novcovek never states a diagnosis. In an emergency, call 112.</span>
          <span>Nothing here ever costs anything.</span>
        </div>
      </div>
    </footer>
  );
}
